/* eslint-disable no-debugger */
import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  isLoading: false,
  error: '',
  headerMsg: '',
  status: true,
  createHeaderStatus: false,
  headerList: [],
  disableHeaderList: []
};

const slice = createSlice({
  name: 'header',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // RESET MSG
    resetHeaderMsg(state) {
      state.headerMsg = '';
    },
    // RESET ERROR
    resetHeaderError(state) {
      state.error = '';
    },
    // RESET CREATE STATUS
    resetCreateHeaderStatus(state) {
      state.createHeaderStatus = false;
    },
    // HAS ERROR
    hasError(state, action) {
      const { message } = action.payload?.data;
      state.createHeaderStatus = false;
      state.isLoading = false;
      state.error = message;
    },
    // STATUS
    headerStatus(state, action) {
      state.isLoading = false;
      state.status = action.payload;
    },
    // GET HEADER LIST
    getHeaderListSuccess(state, action) {
      state.isLoading = false;
      state.headerList = action.payload;
    },
    // GET DISABLE HEADER LIST
    getDisableHeaderListSuccess(state, action) {
      state.isLoading = false;
      state.disableHeaderList = action.payload;
    },
    // CREATE HEADER
    createHeaderSuccess(state, action) {
      const newHeader = action.payload;
      state.createHeaderStatus = true;
      state.isLoading = false;
      state.headerList = [...state.headerList, newHeader];
    },
    // UPDATE HEADER
    updateHeaderSuccess(state, action) {
      const header = action.payload;
      state.createHeaderStatus = true;
      const updateHeader = map(state.headerList, (_header) => {
        if (_header.id === header.id) {
          return header;
        }
        return _header;
      });
      state.isLoading = false;
      state.headerList = updateHeader;
    },
    // FILTER HEADER
    filterHeaderSuccess(state, action) {
      const header = action.payload;
      state.isLoading = false;
      if (state.status) {
        state.headerList = header;
      } else {
        state.disableHeaderList = header;
      }
    },
    // DISABLE OR RESTORE HEADER
    statusChangeSuccess(state, action) {
      if (action.payload.message) {
        state.headerMsg = action.payload.message;
      } else {
        const { id } = action.payload;
        const headerStatus = filter(
          state.status ? state.disableHeaderList : state.headerList,
          (header) => header.id !== id
        );
        state.isLoading = false;
        if (state.status) {
          state.createHeaderStatus = false;
          state.headerMsg = '';
          state.disableHeaderList = headerStatus;
        } else {
          state.createHeaderStatus = true;
          state.headerList = headerStatus;
        }
      }
    },
    // DELETE HEADER
    deleteHeaderSuccess(state, action) {
      const { id } = action.payload;
      const deleteEvent = filter(state.disableHeaderList, (header) => header.id !== id);
      state.isLoading = false;
      state.disableHeaderList = deleteEvent;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { resetCreateHeaderStatus, resetHeaderError, resetHeaderMsg } = slice.actions;

// ----------------------------------------------------------------------

// GET HEADER LIST GET
export function getHeaderList(status) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: `http://smartcollect-api.cp360apps.com/headers/filter/item/?status=${status}`
      });
      if (status) {
        dispatch(slice.actions.getHeaderListSuccess(response.data));
      } else {
        dispatch(slice.actions.getDisableHeaderListSuccess(response.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// CREATE HEADER POST
export function createHeader(headerData) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'post',
        url: 'http://smartcollect-api.cp360apps.com/headers/create/',
        data: headerData
      });
      dispatch(slice.actions.createHeaderSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// EDIT OR UPDATE HEADER PUT
export function updateHeader(headerData, id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'put',
        url: `http://smartcollect-api.cp360apps.com/headers/update/${id}/`,
        data: headerData
      });
      dispatch(slice.actions.updateHeaderSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// SEARCH AND FILTER HEADER GET
export function filterHeader(pageStatus, name) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.headerStatus(pageStatus));
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: `http://smartcollect-api.cp360apps.com/headers/filter/item/?header_name=${name}&status=${pageStatus}`
      });
      dispatch(slice.actions.filterHeaderSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// DISABLING AND RESTORING OF PARTICULAR HEADER PUT
export function statusChange(id, status) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.headerStatus(status));
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'put',
        url: `http://smartcollect-api.cp360apps.com/headers/update-status-${status}/${id}/`
      });
      dispatch(slice.actions.statusChangeSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// DELETE HEADER DELETE
export function deleteHeader(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'delete',
        url: `http://smartcollect-api.cp360apps.com/headers/${id}/`
      });
      dispatch(slice.actions.deleteHeaderSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// ----------------------------------------------------------------------
